import { IMask } from '@utilities/myntr-bundle';

if (!customElements.get('material-field')) {
  class MaterialField extends HTMLElement {
    constructor() {
      super();
      this.label = this.querySelector('label');
      this.input = this.querySelector('input');

      if (!this.input) {
        this.textarea = this.querySelector('textarea');
        if (this.textarea) {
          this.input = this.textarea;
          delete this.textarea;
        }
      }

      if (!this.input && !this.textarea) {
        this.isSelect = true;
        this.input = this.querySelector('select');
        this.inputType = this.input.getAttribute('data-js-select-type');
      } else {
        this.isSelect = false;
        this.inputType = this.input.getAttribute('type');
      }

      this.inputName = this.input.getAttribute('name');

      this.errorMessage = this.getAttribute('data-js-error-message');
      this.hasError = false;
    }

    addErrorMessage() {
      if (this.hasError) return;
      this.hasError = true;
      const errorElement = document.createElement('span');
      errorElement.innerHTML = this.errorMessage;
      errorElement.classList.add('color-error-b');
      errorElement.classList.add('js-error');

      this.appendChild(errorElement);
      this.classList.add('has-error');
    }

    removeErrorMessage() {
      if (!this.hasError) return;
      this.hasError = false;

      const error = this.querySelector('.js-error');

      this.removeChild(error);
      this.classList.remove('has-error');
    }

    validateInputDefault() {
      if (this.input.value != '') return this.removeErrorMessage();
      if (!this.hasError) return this.addErrorMessage();
    }

    validateInputPassword() {
      if (this.input.value.length > 5) return this.removeErrorMessage();
      if (!this.hasError) return this.addErrorMessage();
    }

    validateInputConfirmPassword() {
      const password = this.closest('form').querySelector('input[data-js-password]');
      if (!password) return;

      if (password.value != this.input.value) return this.addErrorMessage();
      return this.removeErrorMessage();
    }

    validateInputEmail() {
      if (this.input.value.match(/^\S+@\S+\.\S+$/)) return this.removeErrorMessage();
      return this.addErrorMessage();
    }

    validateInput() {
      switch (this.inputType) {
        case 'email':
          this.validateInputEmail();
          break;
        case 'password':
          if (this.input.getAttribute('data-js-confirm-password')) return this.validateInputConfirmPassword();
          this.validateInputPassword();
          break;
        case 'province':
          return;
        default:
          this.validateInputDefault();
          break;
      }
    }

    clearSelectClass() {
      this.input.classList.remove('material__select');
    }

    hideProvincesSelect() {
      const select = this.closest('form').querySelector('[data-js-select-type="province"]').closest('material-field');
      this.provincesSelect = select.cloneNode(true);
      this.provincesParent = select.parentNode;

      this.provincesParent.removeChild(select);
    }

    restoreProvincesSelect() {
      this.provincesParent.appendChild(this.provincesSelect);
    }

    handleCountryChange() {
      const selectedOption = this.input.options[this.input.selectedIndex];
      let provinceSelect = this.closest('form').querySelector('[data-js-select-type="province"]');

      if (!provinceSelect || !selectedOption) this.restoreProvincesSelect();

      const provinces = JSON.parse(selectedOption.getAttribute('data-provinces'));
      let provinceOptionsHtml = '';

      if (!provinces?.length) return this.hideProvincesSelect(provinceSelect);

      provinces.forEach((province, index) => {
        provinceOptionsHtml += `<option value='${province[1]}' ${index == 1 ? 'selected' : ''}>${province[0]}</option>`
      });

      if (!provinceSelect) provinceSelect = this.closest('form').querySelector('[data-js-select-type="province"]');

      provinceSelect.innerHTML = provinceOptionsHtml;

      const value = provinceSelect.getAttribute('data-value');

      if (value) {
        provinceSelect.value = value;
        provinceSelect.dispatchEvent(new Event('change'));
      }
    }

    connectedCallback() {
      if (this.isSelect) {
        if (this.inputType == 'country') {
          this.input.addEventListener('change', () => this.handleCountryChange());
        }
        if (this.input.classList.contains("variant__select")) {
          // this.clearSelectClass();
        }

        this.input.addEventListener('change', () => {
          // this.clearSelectClass();
          if (this.inputType == 'country') this.handleCountryChange();
        });

        // Current country and province values for address form
        const value = this.input.getAttribute('data-value');
        if (value) {
          this.input.value = value;
          this.input.dispatchEvent(new Event('change'));
        }

        this.input.classList.add('material__select');
      }

      if (!this.dataset.notRequired) this.input.addEventListener('blur', () => this.validateInput());

      this.addEventListener('click', (event) => {
        this.input.focus();
      });

      if (this.inputType === 'text' && this.inputName == "phone") {
        // using third party masking service, attach a mask to this input.
        const mask = IMask(this.input, {
          mask: '(000) 000-0000'
        });
        // create a hidden input that holds the value that will be validated and sent
        this.hiddenInput = document.createElement('input');
        this.hiddenInput.type = 'hidden';
        this.hiddenInput.name = this.input.name;
        this.hiddenInput.pattern = "[0-9\-]*";
        this.input.removeAttribute('name'); // Remove name attribute from visible input to prevent it from submitting
        this.input.parentNode.insertBefore(this.hiddenInput, this.input.nextSibling);
        // set up an event listener, on this input's update, update the value of the hidden input.
        this.input.addEventListener('input', (event) => { this.hiddenInput.value = mask.unmaskedValue });
      }
    }
  }

  customElements.define('material-field', MaterialField);
}
